module.exports = __webpack_public_path__ + "img/member_cards_icon_431005.3abc0603.png";